export default "__VITE_ASSET__D5teWaX6__"